"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _B2PY6EORcjs = require('../__chunks/B2PY6EOR.cjs');


var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');
require('../__chunks/NSONUP5C.cjs');


var _MSN6U3HDcjs = require('../__chunks/MSN6U3HD.cjs');


var _K6UHAC73cjs = require('../__chunks/K6UHAC73.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/IRJEBRAW.cjs');
require('../__chunks/W5HIR4GY.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-checkbox.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "input";
var useFormCheckbox = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormCheckbox2({
    store,
    name: nameProp,
    value,
    checked,
    defaultChecked,
    ...props
  }) {
    const context = _FHIGX2EEcjs.useFormContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "FormCheckbox must be wrapped in a Form component."
    );
    const name = String(nameProp);
    const checkboxStore = _MSN6U3HDcjs.useCheckboxStore.call(void 0, {
      value: store.useValue(name),
      setValue: (value2) => store == null ? void 0 : store.setValue(name, value2)
    });
    props = _K6UHAC73cjs.useCheckbox.call(void 0, { store: checkboxStore, value, checked, ...props });
    props = _B2PY6EORcjs.useFormControl.call(void 0, {
      store,
      name,
      "aria-labelledby": void 0,
      ...props
    });
    return props;
  }
);
var FormCheckbox = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function FormCheckbox2(props) {
    const htmlProps = useFormCheckbox(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.FormCheckbox = FormCheckbox; exports.useFormCheckbox = useFormCheckbox;
